<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';
import axios from 'axios'

const route = useRoute();
const router = useRouter();

async function logout() {
  let url = "/api/logout"
  try {
    await axios.post(url)
    router.push('/')
  }
  catch (ex) {
    console.log(ex)
  }
}

let loggedIn = computed(() => {
  return route.meta.loggedIn
})

let isQA = computed(() => {
  return window.location.href.indexOf("qa.portal") != -1;
})

const pageDisplay = computed(() => {
  return 'Volunteer Portal - '+ (route.name && route.name.replace(/([A-Z])/g, ' $1').trim()) + (isQA.value ? " [QA] " : "")
})

</script>

<template>
  
  <v-app-bar class="volcor-header">
    <v-btn stacked v-if="loggedIn" disabled>
    </v-btn>
    <v-app-bar-title>{{ pageDisplay }}</v-app-bar-title>
    <v-btn stacked v-if="loggedIn" @click="logout()">
      <v-icon icon="mdi-logout"></v-icon>
    </v-btn>
  
  </v-app-bar>
  
</template>

<style scoped>
.volcor-header {
  background-color: #004d4d !important;
  color: white !important;
}
</style>